import { createFileRoute } from '@tanstack/react-router';
import { AdvisorEditSheet } from '@/pages/advisors/edit-sheet';

export const Route = createFileRoute(
  '/admin/_layout/advisors/_layout/edit/$id'
)({
  component: AdvisorEditRoute,
});

function AdvisorEditRoute() {
  const { id } = Route.useParams();

  return <AdvisorEditSheet id={id} />;
}
